import { createFileRoute } from '@tanstack/react-router';
import {
  installmentListScreen,
  installmentListSearch,
  loadInstallmentMessages,
  loadInstallmentScreens,
} from '@/modules/installment/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';
export const Route = createFileRoute('/_app/gestao-carteira/parcelamentos/')({
  validateSearch: installmentListSearch,
  staticData: { screen: installmentListScreen },
  loader: () => loadInstallmentMessages(),
  component: lazyScreen(loadInstallmentScreens, 'InstallmentListRouteScreen'),
});
